export default __webpack_public_path__ + "static/media/pic3.ba4a5abb.png";